export default __webpack_public_path__ + "static/media/background.677f463b.png";